// extracted by css-extract-rspack-plugin
export default {"BannerDescription":"TradeControlsBanner-module__BannerDescription__jaRfs"};